import React from "react";
import { Route,Redirect,useLocation  } from "react-router-dom";
import Footer from "../layouts/UserNav/Footer";
import NavComponent from "../layouts/UserNav/Navbar";

const user = JSON.parse(localStorage.getItem("USER"))
const role = JSON.parse(localStorage.getItem("ROLE"))

const AuthRoute = ({ component: Component, ...rest }) => {
    const location = useLocation();
    console.log(location)
    console.log("auth log")
    return (
        <>
        <NavComponent/>
        <Route
            {...rest}
            render={props =>
                user? (
                    <Redirect
                        to={{
                            pathname: "/dashboard"
                        }}
                    />
                    
                ) : (
                    <Component {...props} />
                )
            }
        />
        <Footer/>
        </>
    )
}

export default AuthRoute
